// Keeps the login separate between the installed app (PWA) and normal browser tabs.
(function () {
  try {
    var standalone =
      (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
      window.navigator.standalone === true;
    if (!standalone) return;
    var PREFIX = "pwa:";
    var scoped = function (k) { return typeof k === "string" && /token|impersonat/i.test(k); };
    var proto = Storage.prototype;
    var g = proto.getItem, s = proto.setItem, r = proto.removeItem;
    proto.getItem = function (k) {
      return g.call(this, this === window.localStorage && scoped(k) ? PREFIX + k : k);
    };
    proto.setItem = function (k, v) {
      return s.call(this, this === window.localStorage && scoped(k) ? PREFIX + k : k, v);
    };
    proto.removeItem = function (k) {
      return r.call(this, this === window.localStorage && scoped(k) ? PREFIX + k : k);
    };
  } catch (e) { /* ignore */ }
})();
